import React from 'react';

import * as PlaybackActions from './actions';
import * as PlaybackConstants from './constants';
import * as D from './deps';
import PlaybackReducer from './reducer';
import PlaybackWatchers from './sagas/watchers';
import * as PlaybackUtils from './utils';

export default D.createDomainModule({
  name: PlaybackConstants.DOMAIN_NAME,
  actions: PlaybackActions,
  utils: PlaybackUtils,
  constants: PlaybackConstants,
  components: {
    CloseButton: props => {
      return (
        <D.AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_closebutton" */ './components/TunerControls/CloseButton/CloseButton',
            )
          }
        />
      );
    },
    MiniBar: props => {
      return (
        <D.AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_minibar" */ './components/NowPlaying/Session/MiniBar/MiniBar',
            )
          }
        />
      );
    },
    NowPlaying: props => {
      return (
        <D.AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_nowplaying" */ './components/NowPlaying/NowPlaying',
            )
          }
        />
      );
    },
    NowPlayingOnDemand: props => {
      return (
        <D.AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_nowplaying-ondemand" */ './components/NowPlaying/OnDemand/NowPlayingOnDemand/NowPlayingOnDemand',
            )
          }
        />
      );
    },
    NowPlayingSession: props => {
      return (
        <D.AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_nowplaying-session" */ './components/NowPlaying/Session/NowPlayingSession/NowPlayingSession',
            )
          }
        />
      );
    },
    AutoplaySettingRow: props => {
      return (
        <D.AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_autoplaysettingrow" */ './components/AutoplaySettingRow/AutoplaySettingRow',
            )
          }
        />
      );
    },
    SessionCurrent: props => {
      return (
        <D.AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_sessioncurrent" */ './components/NowPlaying/Session/SessionCurrent/SessionCurrent',
            )
          }
        />
      );
    },
    SessionHistory: props => {
      return (
        <D.AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_sessionhistory" */ './components/NowPlaying/Session/SessionHistory/SessionHistory',
            )
          }
        />
      );
    },
    SessionExtras: props => {
      return (
        <D.AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_sessionextras" */ './components/NowPlaying/Session/Extras/Extras',
            )
          }
        />
      );
    },
    SourceList: props => {
      return (
        <D.AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_source-list" */ './components/NowPlaying/Session/SourceList/SourceList',
            )
          }
        />
      );
    },
    Tuner: props => {
      return (
        <D.AsyncComponent
          {...props}
          importer={() =>
            System.import(/* webpackChunkName: "c_tuner" */ './components/Tuner/Tuner')
          }
        />
      );
    },
  },
  selectors: {},
  reducer: PlaybackReducer,
  onLoad() {},
  onStart() {
    this.registeredHandlers = D.registerHandlers(PlaybackWatchers);
  },
  onStop() {
    D.removeAndStopHandlers(this.registeredHandlers, this.name);
  },
});
